import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { Suspense, useState } from "react";
import CustomMap from "./CustomMap";
import MapSkeleton from "../maps/MapSkeleton";

/**
 * کامپوننت قابل استفاده مجدد برای نمایش نقشه
 * این کامپوننت فقط برای نمایش موقعیت روی نقشه استفاده می‌شود (readonly)
 */
const MapViewer = ({
  xPoint,
  yPoint,
  label = "مشاهده موقعیت روی نقشه",
  dialogTitle = "موقعیت روی نقشه",
  showButton = true,
  height = 400,
}) => {
  const [open, setOpen] = useState(false);

  const hasValidCoordinates =
    xPoint != null &&
    yPoint != null &&
    !isNaN(Number(xPoint)) &&
    !isNaN(Number(yPoint)) &&
    Number(xPoint) !== 0 &&
    Number(yPoint) !== 0;

  if (!hasValidCoordinates) {
    return (
      <Typography variant="body2" color="textSecondary">
        {label} - مختصات جغرافیایی موجود نیست
      </Typography>
    );
  }

  const lat = Number(xPoint);
  const lng = Number(yPoint);

  const mapContent = (
    <Suspense fallback={<MapSkeleton height={height} />}>
      <CustomMap
        center={[lat, lng]}
        zoom={15}
        height={height}
        readOnly
        markerPosition={[lat, lng]}
      />
    </Suspense>
  );

  if (!showButton) {
    return (
      <Box>
        <Typography variant="body2" sx={{ mb: 1, fontWeight: 600 }}>
          {label}
        </Typography>
        {mapContent}
      </Box>
    );
  }

  return (
    <Box>
      <Button
        variant="outlined"
        fullWidth
        onClick={() => setOpen(true)}
        sx={{ height: 56 }}
      >
        {label}
      </Button>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            maxHeight: "min(90vh, 640px)",
            display: "flex",
            flexDirection: "column",
          },
        }}
      >
        <DialogTitle sx={{ flexShrink: 0 }}>{dialogTitle}</DialogTitle>
        <DialogContent
          dividers
          sx={{ flex: "1 1 auto", minHeight: 0, overflow: "hidden", p: 2 }}
        >
          {mapContent}
        </DialogContent>
        <DialogActions sx={{ flexShrink: 0 }}>
          <Button onClick={() => setOpen(false)} variant="contained" color="primary">
            بستن
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default MapViewer;
